module.exports = __webpack_public_path__ + "img/estadisticas.4927562f.svg";